export function removeEmptyValues(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
        delete obj[key];
      } else if (typeof obj[key] === 'object') {
        removeEmptyValues(obj[key]); // Recursively check nested objects
        if (Object.keys(obj[key]).length === 0) {
          delete obj[key]; // Remove empty nested objects
        }
      }
    }
    return obj;
}


export function pickFromObject(object, keys) {
  const result = {};
  keys.forEach(key => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}